<template>
    <b-table-simple hover responsive>
        <b-thead>
            <b-th> {{$t('customer.address.name')}} </b-th>
            <b-th> {{$t('customer.address.invoiceType')}} </b-th>
            <b-th> {{$t('customer.address.taxId')}} </b-th>
            <b-th> {{$t('general.city')}} </b-th>
            <b-th> {{$t('general.district')}} </b-th>
            <b-th> {{$t('customer.address.address')}} </b-th>
            <b-th> {{$t('general.default')}} </b-th>
            <b-th> {{$t('customer.list.actions')}} </b-th>
        </b-thead>
        <b-tbody>
            <b-tr v-for="address in data" :key="address.id">
                <b-td> {{address.name}} </b-td>
                <b-td> {{address.invoice_type == 0 ? $t('customer.wizzard.individual'): $t('customer.wizzard.corporate')}} </b-td>
                <b-td> {{address.tax_no}} </b-td>
                <b-td> {{address.city.name}} </b-td>
                <b-td> {{address.town.name}} </b-td>
                <b-td> {{address.address}}</b-td>
                <b-td> 
                    <div v-if="address.default_value" > <b-icon icon="check" variant="success" scale="2" ></b-icon> </div>
                    <div v-else > <b-icon icon="x"  scale="2" variant="danger" ></b-icon>  </div>
                </b-td>
                <b-td> 
                    <b-icon icon="pencil-square" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('general.edit')" @click="openModal( 'edit', address)"></b-icon>
                    <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" :title="$t('general.delete')" @click="openModal( 'delete', address)"></b-icon>
                </b-td>
            </b-tr>
        </b-tbody>
    </b-table-simple>
</template>
               
<script>

    export default {
        name: "AddressForm",
        props:{
            data: Array,
            modalEvent: Function,
            modalType:  Function,
        },
        methods:{
            openModal(name, data){
                this.modalEvent(true, name, data)
            }
        }
      
    }
</script>

<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Customer/components/Addresses.vue